import store from '@/store'
import {
  connectionService,
  RACE_TIMEOUT,
  INTEREST_POINT_CREATE_URI,
  INTEREST_POINT_FETCH_URI,
  INTEREST_POINT_UPDATE_URI,
  INTEREST_POINT_FIND_URI,
  INTEREST_POINT_ERASE_URI
} from '@leapsight/styleguide'
import { i18n } from '@leapsight/portal'

export default {
  pointType: {
    Point: (data, map) => {
      const lat = data.geometry.coordinates[0]
      const lng = data.geometry.coordinates[1]

      const options = {
        map,
        position: new google.maps.LatLng(lat, lng),
        title: data.label
      }

      return new google.maps.Marker(options)
    }
  },
  getConnection() {
    return store.getters['auth/connection']
  },
  getMap() {
    return store.getters['mapState/map']
  },
  getCurrentZone() {
    return store.getters['mapState/currentZone']
  },
  createPoints(point) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const accountId = connectionService.getAccountId()
      const args = [
        {
          ...point,
          account_id: accountId
        }
      ]
      const security = connectionService.createkwArgs()
      const kwArgs = {
        ...security
      }
      connection.session
        .call(INTEREST_POINT_CREATE_URI, args, kwArgs, {})
        .then(
          response => {
            resolve(response.args[0])
          },
          wampError => {
            reject(wampError)
          }
        )
        .catch(err => {
          console.log(err)
        })
    })
  },
  getPoint({ id }) {
    return new Promise((resolve, reject) => {
      const session = store.getters['auth/session']
      const security = connectionService.createkwArgs()
      const args = id
      const kwArgs = {
        ...security
      }
      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, [])
      })
      const p2 = new Promise((resolve, reject) => {
        session
          .call(INTEREST_POINT_FETCH_URI, [args], kwArgs, {})
          .then(response => {
            resolve(response.args[0])
          })
          .catch(error => {
            reject(error)
          })
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPoints(
    { _p } = { _p: 'id,category,color,created_by,geometry,icon,label,description' }
  ) {
    const session = store.getters['auth/session']
    const security = connectionService.createkwArgs()
    const accountId = connectionService.getAccountId()
    const args = { account_id: accountId }
    const kwArgs = {
      ...security,
      query_spec: {
        _p
      }
    }
    const p1 = new Promise((resolve, reject) => {
      setTimeout(reject, RACE_TIMEOUT, [])
    })
    const p2 = new Promise((resolve, reject) => {
      session
        .call(INTEREST_POINT_FIND_URI, [args], kwArgs, {})
        .then(response => {
          resolve(response.args[0])
        })
        .catch(error => {
          reject(error)
        })
    })
    try {
      const value = Promise.race([p1, p2])
      return value
    } catch (error_1) {
      return error_1
    }
  },
  pointOnMap(points, map, notZoomAllPoints) {
    const bounds = new google.maps.LatLngBounds()

    points.forEach(point => {
      if (!point.geometry.hasOwnProperty('coordinates')) return

      const lat = point.geometry.coordinates[0]
      const lng = point.geometry.coordinates[1]
      const position = new google.maps.LatLng(lat, lng)

      const iconUrl =
        point.icon && point.icon.includes('mdi')
          ? `https://cdn.jsdelivr.net/npm/@mdi/svg/svg/${point.icon.replace(
              'mdi-',
              ''
            )}.svg`
          : 'https://cdn.jsdelivr.net/npm/@mdi/svg/svg/map-marker.svg'

      const marker = new google.maps.Marker({
        position,
        map,
        icon: {
          url: iconUrl,
          scaledSize: new google.maps.Size(26, 26),
          labelOrigin: new google.maps.Point(13, 35)
        },
        label: {
          text: point.label,
          color: point.color,
          fontSize: '14px'
        }
      })

      bounds.extend(position)
      store.dispatch('savePointsOnMap', { pointOnMap: marker })
    })

    if (!bounds.isEmpty() && !notZoomAllPoints) {
      map.fitBounds(bounds)
      map.panToBounds(bounds)

      const zoom = map.getZoom()
      if (zoom > 14) {
        map.setZoom(14)
      }
    }
  },
  updatePoint(id, point) {
    return new Promise((resolve, reject) => {
      const connection = this.getConnection()
      const security = connectionService.createkwArgs()
      const args = [id, point]
      const kwArgs = {
        ...security
      }
      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, [])
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session
          .call(INTEREST_POINT_UPDATE_URI, args, kwArgs, {})
          .then(
            response => {
              resolve(response.args[0])
            },
            wampError => {
              console.log(wampError)
              reject(wampError)
            }
          )
      })

      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deletePoint(pointId) {
    return new Promise(resolve => {
      const p1 = new Promise((resolve, reject) => {
        setTimeout(resolve, RACE_TIMEOUT, [])
      })
      const p2 = new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(this.deletePointRace(pointId))
        }, 1000)
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          resolve(error)
        })
    })
  },
  deletePointRace(pointId) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [pointId]
      const kwArgs = connectionService.createkwArgs()
      const options = {}
      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session
          .call(INTEREST_POINT_ERASE_URI, args, kwArgs, options)
          .then(
            response => {
              resolve(response)
            },
            wampError => {
              reject(wampError)
            }
          )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // ERRORS
  getErrorMessageByCode(code = '') {
    let strToReturn
    switch (code) {
      case 'com.magenta.error.constraint_violation':
        strToReturn = i18n.t(
          'fleet_management.points_of_interest.delete_points_of_interest.errors.constraint_violation'
        )
        break
      case 'com.magenta.error.not_found':
        strToReturn = i18n.t(
          'fleet_management.points_of_interest.delete_points_of_interest.errors.not_found'
        )
        break
      case 'com.magenta.error.unexpected_error':
        strToReturn = i18n.t(
          'fleet_management.points_of_interest.delete_points_of_interest.errors.unexpected_error'
        )
        break
      default:
        strToReturn = i18n.t(
          'fleet_management.points_of_interest.delete_points_of_interest.errors.unexpected_error'
        )
        break
    }
    return strToReturn
  }
}
